module.exports = __webpack_public_path__ + "static/media/homepage_4.3370fc5a.jpg";